export const GET_BARCODE_ITEMS = 'GET_BARCODE_ITEMS';
export const GET_BARCODE_ITEMS_SUCCESS = 'GET_BARCODE_ITEMS_SUCCESS';
export const GET_BARCODE_ITEMS_FAILURE = 'GET_BARCODE_ITEMS_FAILURE';
export const SHOW_INVALID_BARCODE_DETAILS ='SHOW_INVALID_BARCODE_DETAILS';
export const RESET_BARCODE_ITEMS ='RESET_BARCODE_ITEMS';
export const SHOW_INVALID_BARCODE_POPUP = 'INVALID_BARCODE_POPUP';
export const RESET_INVALID_BARCODE_DETAILS ='RESET_INVALID_BARCODE_DETAILS';
export const SET_BARCODE_RECEIVE_ITEMS = 'SET_BARCODE_RECEIVE_ITEMS';
export const SUCCESS_MESSAGE_CAMERA = 'SUCCESS_MESSAGE_CAMERA';


